import { PropertyOption } from './types'

export const getPropertyCode = (property: PropertyOption | null) => {
  if (!property || property.ID === 'all') return undefined
  return property.code || 'all'
}

export const dummyData = {
  dataSystems: [
    {
      classificationsByType: [
        {
          classificationType: 'data_category',
          classifications: [
            {
              code: 'unknown',
              description: '',
              name: '',
            },
            {
              code: 'consent',
              description:
                "Includes information related to individuals' consent to the processing of their personal data, including the date, time, and method of obtaining consent.",
              name: 'Consent Data',
            },
            {
              code: 'online_identifiers',
              description:
                'Includes IP addresses, cookies, device IDs, and other online identifiers used to track or identify individuals online.',
              name: 'Online Identifiers',
            },
            {
              code: 'geolocation',
              description:
                'Includes information about the precise location of an individual obtained through GPS, IP address, or other similar technologies.',
              name: 'Geolocation Data',
            },
          ],
        },
      ],
      count: 788,
      dataSystem: {
        code: 'outbrain',
        logoUrl: 'https://cdn.uat.ketchjs.com/locker/v1/assets/logos/outbrain.png',
        name: 'Outbrain',
      },
      trackers: 2,
    },
    {
      classificationsByType: [
        {
          classificationType: 'data_category',
          classifications: [
            {
              code: 'unknown',
              description: '',
              name: '',
            },
            {
              code: 'consent',
              description:
                "Includes information related to individuals' consent to the processing of their personal data, including the date, time, and method of obtaining consent.",
              name: 'Consent Data',
            },
            {
              code: 'online_identifiers',
              description:
                'Includes IP addresses, cookies, device IDs, and other online identifiers used to track or identify individuals online.',
              name: 'Online Identifiers',
            },
          ],
        },
      ],
      count: 648,
      dataSystem: {
        code: 'taboola',
        logoUrl: 'https://cdn.uat.ketchjs.com/locker/v1/assets/logos/taboola.png',
        name: 'Taboola',
      },
      trackers: 1,
    },
    {
      classificationsByType: [
        {
          classificationType: 'data_category',
          classifications: [
            {
              code: 'online_identifiers',
              description:
                'Includes IP addresses, cookies, device IDs, and other online identifiers used to track or identify individuals online.',
              name: 'Online Identifiers',
            },
            {
              code: 'consent',
              description:
                "Includes information related to individuals' consent to the processing of their personal data, including the date, time, and method of obtaining consent.",
              name: 'Consent Data',
            },
            {
              code: 'customer_commercial',
              description:
                'Includes information about customers, such as purchase history, preferences, feedback, or any other data collected during customer interactions.',
              name: 'Customer & Commercial',
            },
            {
              code: 'unknown',
              description: '',
              name: '',
            },
          ],
        },
      ],
      count: 642,
      dataSystem: {
        code: 'ping.chartbeat.net',
        logoUrl: '',
        name: '',
      },
      trackers: 0,
    },
    {
      classificationsByType: [
        {
          classificationType: 'data_category',
          classifications: [
            {
              code: 'unknown',
              description: '',
              name: '',
            },
            {
              code: 'online_identifiers',
              description:
                'Includes IP addresses, cookies, device IDs, and other online identifiers used to track or identify individuals online.',
              name: 'Online Identifiers',
            },
            {
              code: 'consent',
              description:
                "Includes information related to individuals' consent to the processing of their personal data, including the date, time, and method of obtaining consent.",
              name: 'Consent Data',
            },
          ],
        },
      ],
      count: 572,
      dataSystem: {
        code: 'pubmatic',
        logoUrl: 'https://cdn.uat.ketchjs.com/locker/v1/assets/logos/pubmatic.svg',
        name: 'Pubmatic',
      },
      trackers: 1,
    },
    {
      classificationsByType: [
        {
          classificationType: 'data_category',
          classifications: [
            {
              code: 'online_identifiers',
              description:
                'Includes IP addresses, cookies, device IDs, and other online identifiers used to track or identify individuals online.',
              name: 'Online Identifiers',
            },
            {
              code: 'unknown',
              description: '',
              name: '',
            },
            {
              code: 'consent',
              description:
                "Includes information related to individuals' consent to the processing of their personal data, including the date, time, and method of obtaining consent.",
              name: 'Consent Data',
            },
          ],
        },
      ],
      count: 549,
      dataSystem: {
        code: 'amazonads',
        logoUrl: 'https://cdn.uat.ketchjs.com/locker/v1/assets/logos/amazonads.svg',
        name: 'Amazon Ads',
      },
      trackers: 1,
    },
    {
      classificationsByType: [
        {
          classificationType: 'data_category',
          classifications: [
            {
              code: 'unknown',
              description: '',
              name: '',
            },
            {
              code: 'consent',
              description:
                "Includes information related to individuals' consent to the processing of their personal data, including the date, time, and method of obtaining consent.",
              name: 'Consent Data',
            },
            {
              code: 'online_identifiers',
              description:
                'Includes IP addresses, cookies, device IDs, and other online identifiers used to track or identify individuals online.',
              name: 'Online Identifiers',
            },
          ],
        },
      ],
      count: 535,
      dataSystem: {
        code: 'thetradedesk',
        logoUrl: 'https://cdn.uat.ketchjs.com/locker/v1/assets/logos/thetradedesk.png',
        name: 'theTradeDesk',
      },
      trackers: 1,
    },
    {
      classificationsByType: [
        {
          classificationType: 'data_category',
          classifications: [
            {
              code: 'online_identifiers',
              description:
                'Includes IP addresses, cookies, device IDs, and other online identifiers used to track or identify individuals online.',
              name: 'Online Identifiers',
            },
            {
              code: 'unknown',
              description: '',
              name: '',
            },
            {
              code: 'consent',
              description:
                "Includes information related to individuals' consent to the processing of their personal data, including the date, time, and method of obtaining consent.",
              name: 'Consent Data',
            },
          ],
        },
      ],
      count: 525,
      dataSystem: {
        code: 'openx',
        logoUrl: 'https://cdn.uat.ketchjs.com/locker/v1/assets/logos/openx.svg',
        name: 'OpenX',
      },
      trackers: 1,
    },
    {
      classificationsByType: [
        {
          classificationType: 'data_category',
          classifications: [
            {
              code: 'unknown',
              description: '',
              name: '',
            },
            {
              code: 'online_identifiers',
              description:
                'Includes IP addresses, cookies, device IDs, and other online identifiers used to track or identify individuals online.',
              name: 'Online Identifiers',
            },
            {
              code: 'consent',
              description:
                "Includes information related to individuals' consent to the processing of their personal data, including the date, time, and method of obtaining consent.",
              name: 'Consent Data',
            },
          ],
        },
      ],
      count: 522,
      dataSystem: {
        code: 'indexexchange',
        logoUrl: 'https://cdn.uat.ketchjs.com/locker/v1/assets/logos/indexexchange.png',
        name: 'Index Exchange',
      },
      trackers: 1,
    },
    {
      classificationsByType: [
        {
          classificationType: 'data_category',
          classifications: [
            {
              code: 'consent',
              description:
                "Includes information related to individuals' consent to the processing of their personal data, including the date, time, and method of obtaining consent.",
              name: 'Consent Data',
            },
            {
              code: 'online_identifiers',
              description:
                'Includes IP addresses, cookies, device IDs, and other online identifiers used to track or identify individuals online.',
              name: 'Online Identifiers',
            },
            {
              code: 'unknown',
              description: '',
              name: '',
            },
          ],
        },
      ],
      count: 416,
      dataSystem: {
        code: 'iponweb(bycriteo)',
        logoUrl: 'https://cdn.uat.ketchjs.com/locker/v1/assets/logos/criteo.svg',
        name: 'IponWeb (by Criteo)',
      },
      trackers: 0,
    },
    {
      classificationsByType: [
        {
          classificationType: 'data_category',
          classifications: [
            {
              code: 'unknown',
              description: '',
              name: '',
            },
            {
              code: 'consent',
              description:
                "Includes information related to individuals' consent to the processing of their personal data, including the date, time, and method of obtaining consent.",
              name: 'Consent Data',
            },
          ],
        },
      ],
      count: 382,
      dataSystem: {
        code: 'yahoo!ads',
        logoUrl: 'https://cdn.uat.ketchjs.com/locker/v1/assets/logos/yahoo.png',
        name: 'Yahoo! Ads',
      },
      trackers: 2,
    },
    {
      classificationsByType: [
        {
          classificationType: 'data_category',
          classifications: [
            {
              code: 'unknown',
              description: '',
              name: '',
            },
            {
              code: 'consent',
              description:
                "Includes information related to individuals' consent to the processing of their personal data, including the date, time, and method of obtaining consent.",
              name: 'Consent Data',
            },
            {
              code: 'online_identifiers',
              description:
                'Includes IP addresses, cookies, device IDs, and other online identifiers used to track or identify individuals online.',
              name: 'Online Identifiers',
            },
          ],
        },
      ],
      count: 379,
      dataSystem: {
        code: 'triplelift',
        logoUrl: 'https://cdn.uat.ketchjs.com/locker/v1/assets/logos/triplelift.svg',
        name: 'TripleLift',
      },
      trackers: 1,
    },
    {
      classificationsByType: [
        {
          classificationType: 'data_category',
          classifications: [
            {
              code: 'online_identifiers',
              description:
                'Includes IP addresses, cookies, device IDs, and other online identifiers used to track or identify individuals online.',
              name: 'Online Identifiers',
            },
            {
              code: 'unknown',
              description: '',
              name: '',
            },
            {
              code: 'consent',
              description:
                "Includes information related to individuals' consent to the processing of their personal data, including the date, time, and method of obtaining consent.",
              name: 'Consent Data',
            },
          ],
        },
      ],
      count: 349,
      dataSystem: {
        code: 'microsoftads',
        logoUrl: 'https://cdn.uat.ketchjs.com/locker/v1/assets/logos/microsoftbingads.svg',
        name: 'Microsoft Ads',
      },
      trackers: 3,
    },
    {
      classificationsByType: [
        {
          classificationType: 'data_category',
          classifications: [
            {
              code: 'unknown',
              description: '',
              name: '',
            },
            {
              code: 'online_identifiers',
              description:
                'Includes IP addresses, cookies, device IDs, and other online identifiers used to track or identify individuals online.',
              name: 'Online Identifiers',
            },
          ],
        },
      ],
      count: 333,
      dataSystem: {
        code: 'a57.foxnews.com',
        logoUrl: '',
        name: '',
      },
      trackers: 0,
    },
    {
      classificationsByType: [
        {
          classificationType: 'data_category',
          classifications: [
            {
              code: 'unknown',
              description: '',
              name: '',
            },
            {
              code: 'online_identifiers',
              description:
                'Includes IP addresses, cookies, device IDs, and other online identifiers used to track or identify individuals online.',
              name: 'Online Identifiers',
            },
          ],
        },
      ],
      count: 220,
      dataSystem: {
        code: 'static.foxnews.com',
        logoUrl: '',
        name: '',
      },
      trackers: 0,
    },
    {
      classificationsByType: [
        {
          classificationType: 'data_category',
          classifications: [
            {
              code: 'online_identifiers',
              description:
                'Includes IP addresses, cookies, device IDs, and other online identifiers used to track or identify individuals online.',
              name: 'Online Identifiers',
            },
            {
              code: 'consent',
              description:
                "Includes information related to individuals' consent to the processing of their personal data, including the date, time, and method of obtaining consent.",
              name: 'Consent Data',
            },
            {
              code: 'unknown',
              description: '',
              name: '',
            },
          ],
        },
      ],
      count: 216,
      dataSystem: {
        code: 'frontdoor.knotch.it',
        logoUrl: '',
        name: '',
      },
      trackers: 0,
    },
    {
      classificationsByType: [
        {
          classificationType: 'data_category',
          classifications: [
            {
              code: 'online_identifiers',
              description:
                'Includes IP addresses, cookies, device IDs, and other online identifiers used to track or identify individuals online.',
              name: 'Online Identifiers',
            },
            {
              code: 'customer_commercial',
              description:
                'Includes information about customers, such as purchase history, preferences, feedback, or any other data collected during customer interactions.',
              name: 'Customer & Commercial',
            },
            {
              code: 'unknown',
              description: '',
              name: '',
            },
          ],
        },
      ],
      count: 190,
      dataSystem: {
        code: 'smetrics.foxnews.com',
        logoUrl: '',
        name: '',
      },
      trackers: 0,
    },
    {
      classificationsByType: [
        {
          classificationType: 'data_category',
          classifications: [
            {
              code: 'unknown',
              description: '',
              name: '',
            },
            {
              code: 'online_identifiers',
              description:
                'Includes IP addresses, cookies, device IDs, and other online identifiers used to track or identify individuals online.',
              name: 'Online Identifiers',
            },
            {
              code: 'consent',
              description:
                "Includes information related to individuals' consent to the processing of their personal data, including the date, time, and method of obtaining consent.",
              name: 'Consent Data',
            },
          ],
        },
      ],
      count: 187,
      dataSystem: {
        code: 'optimizely',
        logoUrl: 'https://cdn.uat.ketchjs.com/locker/v1/assets/logos/optimizely.svg',
        name: 'Optimizely',
      },
      trackers: 4,
    },
    {
      classificationsByType: [
        {
          classificationType: 'data_category',
          classifications: [
            {
              code: 'unknown',
              description: '',
              name: '',
            },
            {
              code: 'consent',
              description:
                "Includes information related to individuals' consent to the processing of their personal data, including the date, time, and method of obtaining consent.",
              name: 'Consent Data',
            },
            {
              code: 'online_identifiers',
              description:
                'Includes IP addresses, cookies, device IDs, and other online identifiers used to track or identify individuals online.',
              name: 'Online Identifiers',
            },
          ],
        },
      ],
      count: 163,
      dataSystem: {
        code: 'intentiq',
        logoUrl: 'https://cdn.uat.ketchjs.com/locker/v1/assets/logos/intentiq.svg',
        name: 'IntentIQ',
      },
      trackers: 2,
    },
    {
      classificationsByType: [
        {
          classificationType: 'data_category',
          classifications: [
            {
              code: 'online_identifiers',
              description:
                'Includes IP addresses, cookies, device IDs, and other online identifiers used to track or identify individuals online.',
              name: 'Online Identifiers',
            },
            {
              code: 'unknown',
              description: '',
              name: '',
            },
          ],
        },
      ],
      count: 147,
      dataSystem: {
        code: 'ai.browsiprod.com',
        logoUrl: '',
        name: '',
      },
      trackers: 0,
    },
    {
      classificationsByType: [
        {
          classificationType: 'data_category',
          classifications: [
            {
              code: 'consent',
              description:
                "Includes information related to individuals' consent to the processing of their personal data, including the date, time, and method of obtaining consent.",
              name: 'Consent Data',
            },
            {
              code: 'unknown',
              description: '',
              name: '',
            },
          ],
        },
      ],
      count: 147,
      dataSystem: {
        code: 'truaudience(bytransunion)',
        logoUrl: 'https://cdn.uat.ketchjs.com/locker/v1/assets/logos/truaudience(bytransunion).svg',
        name: 'TruAudience (by Transunion)',
      },
      trackers: 1,
    },
  ],
  total: 73,
}
export const colorPalette = ['#15005A', '#1463BB', '#3EB3CD', '#D1E0ED', '#B1BFFF', '#d2baff']
